import { useCallback } from "react";

export default function PermissionPreviewHelpers({
  normalizePermissionKeys,
  permissionRows,
  texts
}) {
  const getPermissionNames = useCallback((permissionKeys) => {
    return normalizePermissionKeys(permissionKeys)
      .map((permissionKey) => permissionRows.find((permission) => permission.key === permissionKey)?.name || permissionKey)
      .filter(Boolean);
  }, [normalizePermissionKeys, permissionRows]);

  const getPermissionPreviewMeta = useCallback((permissionKeys, maxVisible = 3) => {
    const names = getPermissionNames(permissionKeys);
    if (!names.length) {
      return {
        fullText: "",
        previewText: texts.none,
        badgeText: "",
        hiddenCount: 0
      };
    }

    const visible = names.slice(0, maxVisible);
    const hiddenCount = Math.max(names.length - visible.length, 0);

    return {
      fullText: names.join(" / "),
      previewText: visible.join(" / "),
      badgeText: hiddenCount ? `+${hiddenCount}` : "",
      hiddenCount
    };
  }, [getPermissionNames, texts.none]);

  return { getPermissionPreviewMeta };
}